<template>
  <div class="project-status">
    <span class="status" :class="item.status">
      {{ $t('project.status.' + item.status) }}
      <span v-if="showDate">
        {{finishDate}}
      </span>
    </span>
  </div>
</template>

<script>

import moment from 'moment';
import { projectStatuses } from '@/constants/projects';

export default {
  name: 'ProjectStatus',
  props: {
    item: {
      type: Object,
      required: true,
    },
    showFinishDate: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    finishDate() {
      if (this.item.actualEndDate || this.item.endDate) {
        return moment(this.item.actualEndDate || this.item.endDate).format('D MMM, yyyy');
      }
      return '';
    },
    showDate() {
      return this.item.status === projectStatuses.FINISHED && this.showFinishDate;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.project-status {
  display: var(--displaystatuscell, block);

  .status {
    text-transform: uppercase;
    border-radius: $radius-sm;
    padding: 5px;
    font-size: rem(12);
    background-color: var(--status-neutral-bg);
    color: var(--status-neutral);

    &.scoping {
      background-color: var(--status-warning-bg);
      color: var(--status-warning);
    }

    &.pending {
      background-color: var(--severity-high-bg);
      color: var(--severity-high);
    }

    &.in-queue {
      background-color: var(--status-success-bg);
      color: var(--status-success);
    }

    &.declined {
      background-color: var(--status-error-bg);
      color: var(--status-error);
    }

    &.canceled {
      background-color: var(--status-neutral-bg);
      color: var(--status-neutral);
    }

    &.in-progress {
      background-color: var(--status-success-bg);
      color: var(--status-success);
    }

    &.on-hold {
      background-color: var(--status-info-bg);
      color: var(--status-info);
    }

    &.finished {
      background-color: var(--status-info-bg);
      color: var(--status-info);
    }

    &.failed {
      background-color: var(--status-error-bg);
      color: var(--status-error);
    }

    &.repeat-in-progress {
      background-color: var(--status-success-bg);
      color: var(--status-success);
    }
  }
}
</style>
